import * as React from "react";

import { DataLocalService } from "src/core/services/data-local.service";
import { DataTableView, ToolbarVisibility, Column } from 'src/core/ui/data-table.view';
import { ObjectUtils } from "src/core/utils/object";

interface SupplementListProp {
	unitTitle: string;
	parent: ProductSearchResult;
	items: ResultOption[];
	setBusy: (isBusy: boolean) => void;
	selection: { [unitIndex: string]: ResultSelection };
	onChangeSelection: (selectedRowKeys: string[] | number[], selectedRows: Object[]) => any;
	unitIndex: number;
}

export const SupplementList: React.SFC<SupplementListProp> = ({ unitTitle, parent, items, onChangeSelection, selection, setBusy, unitIndex }) => {
	const breakdown: ResultOption[] = [];
	if(selection){
		for (const item of items) {
			if(selection[unitIndex]&&item.parent.id===selection[unitIndex].selected.id){
				breakdown.push(item);
			}
		}
	}
	if (breakdown.length === 0) {
		return null;
	}
	breakdown.sort((x, y) => x.unitIndex - y.unitIndex);
	const dataSet: any = new DataLocalService(breakdown, 40);
	return (
		<DataTableView
			rowKey={getKey}
			mode="display"
			setBusy={setBusy}
			hideToolbar={ToolbarVisibility.hideSearch | ToolbarVisibility.hideModifyButtons | ToolbarVisibility.hidePagination}
			columns={columns(unitTitle)}
			model={dataSet}
			selection={
				{
					getCheckboxProps: disableRequiredItems,
					selectedRowKeys: breakdown
						.filter(e => (e.result as SupplementSearchResult).isRequired || selection && selection[e.unitIndex] && selection[e.unitIndex].supDisc.some(s => s.id === e.id))
						.map(e => `${e.unitIndex}-${e.id}`),
					onChange: onChangeSelection
				}
			}
		/>
	);
}

const columns = (unitTitle: string): Column[] => [
	{
		key: 'name',
		dataIndex: 'result.product.name',
		title: 'Name'
	},
	{
		key: "sell",
		dataIndex: "sell.totalPrice",
		title: "Price",
		render: (text, record: ResultOption) => {
			return `${text} ${record.sell.currencyIsoCode}`
		},
		width: "6rem"
	},
	{
		key: "cost",
		dataIndex: "cost",
		title: "Margin",
		render: (text: Money, record: ResultOption) => {
			const margin = record.sell.totalPrice - (record.cost.totalPrice * record.sell.exchangeRate);
			return `${ObjectUtils.round(margin)} ${record.sell.currencyIsoCode}`;
		},
		width: "6rem"
	},
];

const getKey = (record: ResultOption) => `${record.unitIndex}-${record.id}`;

const getTitle = () => <b>Supplements/Discounts</b>;

const disableRequiredItems = (record: ResultOption) => ({
	disabled: (record.result as SupplementSearchResult).isRequired,
});



// WEBPACK FOOTER //
// ./src/app/bookings/search/results/search-results-supplement.view.tsx